import { moduleApi } from "@amtana/module";

import type {
  ClearOverrideInput,
  FlagOverride,
  FlagsOverviewOutput,
  IsEnabledInput,
  ResolveAllInput,
  ResolveAllOutput,
  SetOverrideInput,
} from "./feature-flag.schemas.ts";

// The promise feature-flag makes to the rest of the platform (ADR-006): resolve one flag or
// every organization-scoped one, forced value first, then the organization's own override,
// then the platform's, then the catalogue default (S8.02). `setOverride`, `clearOverride` and
// `overview` are peer-only: no transport door here calls them (S8.06, ADR-006 point 8 decides
// the staff door lives on `modules/ops`, which reaches this module as a peer, recording its
// own staff audit); tests reach them the same way.
export interface FeatureFlagApi {
  /** Resolves one flag for an organization (platform flags ignore it, so this is safe to call for either). */
  isEnabled(input: IsEnabledInput): Promise<boolean>;
  /** Every organization-scoped flag's value for one organization (S8.04's browser hands this to the shell). */
  resolveAll(input: ResolveAllInput): Promise<ResolveAllOutput>;
  /** Sets or replaces the override for a flag, scoped to an organization or the whole platform. */
  setOverride(input: SetOverrideInput): Promise<FlagOverride>;
  /** Clears a stored override outright, including an orphaned one; resolution falls through
   * to the next scope. */
  clearOverride(input: ClearOverrideInput): Promise<void>;
  /** Every catalogued flag with its default, its platform override and the organizations
   * whose override differs from it, plus any orphaned stored override (S8.06). */
  overview(): Promise<FlagsOverviewOutput>;
}

export const FeatureFlagApi = moduleApi<FeatureFlagApi>()("feature-flag");
